import NewUserPageContent from './NewUserPageContent'
import Page from '../../layout/Page'

const NewUserPage = () => <Page content={<NewUserPageContent />} />

export default NewUserPage
